import { ComboRateChart } from "src/components/common/chart/ComboRateChart";

import { SAL2100_R01MonthlyDto } from "../Dto_SAL2100_R01";

export const SalesChart_SAL2100_R01 = ({ data }: { data: SAL2100_R01MonthlyDto[] }) => (
	<ComboRateChart
		data={data}
		barSeries={[
			{ field: "salesAmount", label: "매출액", color: "#00c853" },
			{ field: "costAmount", label: "매출원가", color: "#ff6666" },
		]}
		lineSeries={{ field: "profitRate", label: "이익률(%)", color: "#2fc3e8" }}
		y1={{ min: 0, max: 100, suffix: "%" }}
		height={300}
	/>
);
